import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import EditMobileService from "./Form";
import { FormGroupHeader } from "@/components/shared";
import { ActionButtonConfig } from "@/components/shared/FormGroupHeader";
import { useTranslation } from "react-i18next";
import { ServicePermission } from "@/graphql/__generated__/graphql";
import { useServicePermissionsData } from "@/hooks/cache";
import EditMobileServiceModal from "../../Components/EditMobileServiceModal";
import { appendOpOrgIdParams } from "@/utils/helpers";

const EditMobileServiceComponent = () => {

  // Hooks
  const navigate = useNavigate();
  const { t } = useTranslation(["translation", "common"]);
  const { tenderID: currentTenderID, serviceID } = useParams<{ tenderID: string, serviceID: string, operationalOrganizationID: string }>();
  const [searchParams] = useSearchParams();
  const currentOperationalOrganizationID = searchParams.get("operationalOrganizationId");
  const servicePermissionsData = useServicePermissionsData({ serviceID: serviceID as string, type: "Mobile" });

  // Constants
  const userCanEdit = servicePermissionsData?.permissions.includes(ServicePermission.Edit);

  /**
   * OnClick handler for the Back button
   * Constructs the navigation path based on the current mode and requestID.
  */
  const handleBackClick = () => {
    const path = `/tender/${currentTenderID}/services/all${appendOpOrgIdParams(currentOperationalOrganizationID)}`;

    navigate(path);
  };

  // Action buttons for FormGroupHeader
  const actionButtons: ActionButtonConfig[] = [
    {
      text: t("common:buttons.back"),
      actionFn: handleBackClick,
      variant: "outline",
    }
  ].filter(Boolean) as ActionButtonConfig[];

  return (
    <>
      <FormGroupHeader
        actionButtons={actionButtons}
        title={userCanEdit ? t("mobileservice.edittitle"): t("mobileservice.viewtitle")}
        description={`${userCanEdit ? t("mobileservice.edit"): t("mobileservice.view") } ${t("mobileservice.editviewdescription")}`}
        className="pr-4 pl-2"
      >
        <EditMobileServiceModal />
      </FormGroupHeader>

      <div className="pr-4 pl-2 pb-[300px]">
        <EditMobileService userCanEdit={userCanEdit as boolean} />
      </div>
    </>
  );
};

export default EditMobileServiceComponent;
